/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tutorials': {
    width: 24,
    height: 20,
    viewBox: '0 0 24 20',
    data: '<path pid="0" d="M23.586 0H.414A.414.414 0 000 .414V18.62c0 .229.185.413.414.413h23.172a.414.414 0 00.414-.413V.414A.414.414 0 0023.586 0zM4.138 18.207H.828v-3.724h3.31v3.724zm0-4.552H.828V9.931h3.31v3.724zm0-4.552H.828V5.38h3.31v3.724zm0-4.551H.828V.828h3.31v3.724zm10.98 5.314l-4.551 2.897a.417.417 0 01-.421.014.414.414 0 01-.215-.363V6.62a.414.414 0 01.636-.35l4.552 2.897a.415.415 0 010 .698zm8.054 8.34h-3.31v-3.723h3.31v3.724zm0-4.55h-3.31V9.93h3.31v3.724zm0-4.553h-3.31V5.38h3.31v3.724zm0-4.551h-3.31V.828h3.31v3.724z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
